import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'shared-online-menu-nav',
    templateUrl: './online-menu-nav.shared.component.html',
    styleUrls: ['./online-menu-nav.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OnlineMenuNavComponent {
    public get delayScroll(): number {
        return 200;
    }

    public get isMobile(): boolean {
        return window.innerWidth < 768;
    }
}
